"use client";
import { createContext, useContext, useMemo, useState } from "react";

const CartContext = createContext();

const CartProvider = (props) => {
  const { children } = props;
  const [cartTotalsInfo, setCartTotalsInfo] = useState(null);
  const [showMiniCart, setShowMiniCart] = useState(false);

  const value = useMemo(
    () => ({
      showMiniCart,
      setShowMiniCart,
      cartTotalsInfo,
      setCartTotalsInfo,
    }),
    [showMiniCart, setShowMiniCart, cartTotalsInfo, setCartTotalsInfo]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

function useCartContext() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error("useCartContext must be used within a CartContext");
  }
  return context;
}

export { CartProvider, useCartContext, CartContext };
